import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { AuthShell, inputCls } from "./Login";
import { apiError } from "../lib/api";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ name: "", email: "", phone: "", company: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await register(form);
      navigate(location.state?.next || "/app");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Create your account" subtitle="Start shipping domestic & international in minutes">
      <form onSubmit={submit} className="space-y-4">
        {error && <p data-testid="register-error" className="rounded-lg bg-red-50 px-4 py-2.5 text-sm text-red-700">{error}</p>}
        <div className="grid grid-cols-2 gap-4">
          <div className="col-span-2">
            <label className="mb-1 block text-xs font-semibold uppercase tracking-wider text-slate-500">Full Name</label>
            <input required data-testid="register-name-input" className={inputCls} value={form.name} onChange={set("name")} placeholder="Priya Sharma" />
          </div>
          <div className="col-span-2">
            <label className="mb-1 block text-xs font-semibold uppercase tracking-wider text-slate-500">Email</label>
            <input type="email" required data-testid="register-email-input" className={inputCls} value={form.email} onChange={set("email")} placeholder="you@company.com" />
          </div>
          <div>
            <label className="mb-1 block text-xs font-semibold uppercase tracking-wider text-slate-500">Phone</label>
            <input data-testid="register-phone-input" className={inputCls} value={form.phone} onChange={set("phone")} placeholder="98XXXXXXXX" />
          </div>
          <div>
            <label className="mb-1 block text-xs font-semibold uppercase tracking-wider text-slate-500">Company <span className="text-slate-400 normal-case">opt.</span></label>
            <input data-testid="register-company-input" className={inputCls} value={form.company} onChange={set("company")} placeholder="Acme Pvt Ltd" />
          </div>
          <div className="col-span-2">
            <label className="mb-1 block text-xs font-semibold uppercase tracking-wider text-slate-500">Password</label>
            <input type="password" required minLength={8} data-testid="register-password-input" className={inputCls}
                   value={form.password} onChange={set("password")} placeholder="Minimum 8 characters" />
          </div>
        </div>
        <button type="submit" disabled={loading} data-testid="register-submit-btn"
                className="flex w-full items-center justify-center gap-2 rounded-lg bg-saffron py-3 text-sm font-bold text-white shadow-lg shadow-saffron/30 transition-colors hover:bg-saffron-hover disabled:opacity-60">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Create Account
        </button>
      </form>
      <p className="mt-6 text-center text-sm text-slate-500">
        Already shipping? <Link to="/login" data-testid="register-login-link" className="font-bold text-saffron hover:underline">Login</Link>
      </p>
    </AuthShell>
  );
}
